import * as React from "react";
import i18n from "i18n";
import {
  IconButton,
  Popover,
  Grid,
  Typography,
  Button,
  withStyles,
  Tooltip,
} from "@material-ui/core";
import { LoginStore } from "modules/login/LoginStore";
import { AccountCircle } from "@material-ui/icons";
import { NavLink } from "react-router-dom";
import { observer } from "mobx-react";
import { createBlankUser } from "modules/login/models/User";
import { Redirect } from "react-router-dom";
import { DevelopmentStore } from "modules/development/DevelopmentStore";

const styles = (theme) => ({
  popover: {
    width: "260px",
  },
  profileInfos: {
    padding: "20px",
    borderBottom: "1px solid #c1c1c1",
  },
  containerBigPicture: {
    height: "64px",
    width: "64px",
    borderRadius: "32px",
    overflow: "hidden",
    margin: "auto",
  },
  profilePicture: {
    height: "64px",
    width: "64px",
    // fontSize: '64px',
  },
  profilePictureContainer: {
    textAlign: "center" as any,
  },
  name: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    color: "#000000",
    maxWidth: "140px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap" as any,
    overflow: "hidden",
  },
  email: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 400,
    color: "#000000",
    marginBottom: "5px",
  },
  leaveContainer: {
    padding: "10px 20px",
    transition: "all 0.3s ease-in",
    "&:hover": {
      backgroundColor: "#FAFAFA",
    },
    marginTop: "5px",
  },
  leave: {
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: 400,
    color: "#bbb",
    cursor: "pointer",
    display: "inline",
    transition: "all 0.3s ease-in",
    borderRadius: "50%",
    padding: "5px",
  },
  link: {
    textDecoration: "none",
  },
  icon: {
    height: "28px",
    width: "28px",
  },
  container: {
    height: "28px",
    width: "28px",
    borderRadius: "14px",
    overflow: "hidden",
  },
  imgHigh: {
    top: "-100%",
    left: 0,
    right: 0,
    bottom: "-100%",
    margin: "auto",
    width: "100%",
  },
  imgLong: {
    left: "-100%",
    top: 0,
    bottom: 0,
    right: "-100%",
    margin: "auto",
    height: "100%",
  },
  tooltip: {
    width: "140px",
  },
});

type IProps = {
  classes: any;
};

@observer
class ProfileOverlay extends React.Component<IProps> {
  state = {
    open: false,
  };
  constructor(props) {
    super(props);
    this.setClassName = this.setClassName.bind(this);
  }

  handleOpen = () => this.setState({ open: true });
  handleClose = () => this.setState({ open: false });

  signOut() {
    LoginStore.signOutUser();
    DevelopmentStore.developments = [];
    DevelopmentStore.developmentsSearch = [];
    DevelopmentStore.developmentsView = [];
  }

  renderRedirect = () => {
    if (!LoginStore.isUserAuth) {
      return <Redirect to="/Login/" />;
    } else return false;
  };

  setClassName(node: any) {
    if (node) {
      const { classes } = this.props;
      if (node.clientWidth > node.clientHeight)
        node.className = classes.imgLong;
      else node.className = classes.imgHigh;
    }
  }

  render() {
    const { classes } = this.props,
      { open } = this.state;
    const user =
      LoginStore.userAuth != undefined
        ? LoginStore.userAuth
        : createBlankUser();
    return (
      <React.Fragment>
        {this.renderRedirect()}
        <span ref="anchorEl">
          <IconButton component="span" onClick={this.handleOpen}>
            {user.photoURL != "" ? (
              <span
                className={classes.container}
                style={{ position: "relative" }}
              >
                <img
                  src={user.photoURL}
                  ref={this.setClassName}
                  style={{ position: "absolute" }}
                />
              </span>
            ) : (
              <AccountCircle
                className={classes.icon}
                style={{ color: "#fff" }}
              />
            )}
          </IconButton>
        </span>
        <Popover
          open={open}
          anchorEl={this.refs.anchorEl as any}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          classes={{ paper: classes.popover }}
        >
          <Grid container>
            <Grid item xs={12}>
              <Grid container className={classes.profileInfos} spacing={8}>
                <Grid item xs={4} className={classes.profilePictureContainer}>
                  {user.photoURL != "" ? (
                    <div
                      className={classes.containerBigPicture}
                      style={{ position: "relative" }}
                    >
                      <img
                        src={user.photoURL}
                        ref={this.setClassName}
                        style={{ position: "absolute" }}
                      />
                    </div>
                  ) : (
                    <AccountCircle className={classes.profilePicture} />
                  )}
                </Grid>
                <Grid item xs={8}>
                  <Tooltip
                    className={classes.tooltip}
                    title={
                      LoginStore.userAuth ? LoginStore.userAuth.displayName : ""
                    }
                  >
                    <Typography className={classes.name}>
                      {LoginStore.userAuth
                        ? LoginStore.userAuth.displayName
                        : ""}
                    </Typography>
                  </Tooltip>
                  <Typography className={classes.email}>
                    {LoginStore.userAuth ? LoginStore.userAuth.email : ""}
                  </Typography>
                  {!LoginStore.expiredTrial() && (
                    <NavLink to="/menu/profile" className={classes.link}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleClose}
                      >
                        {i18n.menu.account.view}
                      </Button>
                    </NavLink>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className={classes.leaveContainer}>
              <div>
                <Typography
                  onClick={() => this.signOut()}
                  className={classes.leave}
                  component="span"
                >
                  {i18n.menu.account.leave}
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Popover>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(ProfileOverlay);



// WEBPACK FOOTER //
// ./src/modules/menu/components/layouts/ProfileOverlay.tsx